import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PeriodHeaderContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1}
    width: 100%;
    color: ${({ theme }) => theme.Text.secondary};
`;

export const GoalsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    width: 100%;
`;
